import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['identifier']
  removeIdentifier() {
    this.identifierTargets.forEach((element) => element.remove())
  }
}

